import ConcreteCashDetails from './components/ConcreteCashDetails';
import Details from './components/Details';

import { currencyDefaults, locale } from '../../../../utils/intl';
import { customer$, profileState$ } from '../../../../store/profile/selectors';
import { supplierById$ } from '../../../../store/entities/selectors';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import capitalize from 'capitalize';
import { useSelector } from 'react-redux';

import type { Customer, Profile as ProfileType } from 'foundshared/src/api/profile/types';
import type { ReactNode } from 'react';
import type { Supplier } from 'foundshared/src/api/suppliers/types';



export interface ProfileDetailsProps {
  children?: ReactNode;
}

const currency = new Intl.NumberFormat(locale, {
  ...currencyDefaults,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const profileGrid = (profile: ProfileType) => [
  { title: 'First name', value: profile.firstName },
  { title: 'Last name', value: profile.lastName },
  { title: 'Email', value: profile.email },
  { title: 'Mobile', value: profile.mobile },
];

const customerGrid = (customer: Customer, supplier: Supplier) => [
  { title: 'Company name', value: customer.name },
  { title: 'Occupation', value: customer.occupation },
  { title: 'Credit terms', value: capitalize(customer.creditTerms) },
  { title: 'Credit limit', value: currency.format(customer.creditLimit) },
  { title: 'Outstanding total', value: currency.format(customer.outstandingTotal) },
  { title: 'Supplier Preference', value: supplier.name },
];

function ProfileDetails() {
  const customer = useSelector(customer$);
  const profile = useSelector(profileState$);
  const supplier = useSelector(supplierById$(customer?.preferredSupplierBrandId));

  return (
    <>
      <Box py={3}>
        <Typography variant="h3" component="h3">
          Profile
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          {!!profile && <Details cardTitle="User Details" titleXs={4} valueXs={8} data={profileGrid(profile)} />}
        </Grid>
        <Grid item xs={12} md={6} xl={4}>
          {!!customer && (
            <Details cardTitle="Customer Details" titleXs={6} valueXs={6} data={customerGrid(customer, supplier)} />
          )}
        </Grid>
        <Grid item xs={12} md={6} xl={4}>
          <ConcreteCashDetails />
        </Grid>
      </Grid>
    </>
  );
}

export default ProfileDetails;
